import * as fromDatatype from "../datatype-library/index";

export interface bl_del_trip_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    guid_driver_hdr: fromDatatype.GuidDataFieldInterface;
    guid_vehicle_hdr: fromDatatype.GuidDataFieldInterface;
    guid_region_hdr: fromDatatype.GuidDataFieldInterface;
    running_number_01: fromDatatype.BigIntegerDatatypeInterface;
    running_number_02: fromDatatype.BigIntegerDatatypeInterface;
    running_number_03: fromDatatype.BigIntegerDatatypeInterface;
    trip_start_date: fromDatatype.TimestampTzDatatypeInterface;
    trip_end_date: fromDatatype.TimestampTzDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    label_list_guid: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    date_created: fromDatatype.TimestampTzDatatypeInterface;
    date_updated: fromDatatype.TimestampTzDatatypeInterface;    
    delivery_status: fromDatatype.VarcharDatatypeInterface;
    delivery_logic: fromDatatype.VarcharDatatypeInterface;
    process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_status_guid: fromDatatype.GuidDataFieldInterface;
    process_status_name: fromDatatype.VarcharDatatypeInterface;
    process_resolution_guid: fromDatatype.GuidDataFieldInterface;
    process_resolution_code: fromDatatype.VarcharDatatypeInterface;
    driver_name: fromDatatype.VarcharArrayDatatypeInterface;
    third_party_driver: fromDatatype.VarcharArrayDatatypeInterface;
    trip_driver_helper_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_del_trip_hdr_RowClass implements bl_del_trip_hdr_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    guid_driver_hdr: fromDatatype.GuidDataFieldInterface;
    guid_vehicle_hdr: fromDatatype.GuidDataFieldInterface;
    guid_region_hdr: fromDatatype.GuidDataFieldInterface;
    running_number_01: fromDatatype.BigIntegerDatatypeInterface;
    running_number_02: fromDatatype.BigIntegerDatatypeInterface;
    running_number_03: fromDatatype.BigIntegerDatatypeInterface;
    trip_start_date: fromDatatype.TimestampTzDatatypeInterface;
    trip_end_date: fromDatatype.TimestampTzDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    label_list_guid: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    date_created: fromDatatype.TimestampTzDatatypeInterface;
    date_updated: fromDatatype.TimestampTzDatatypeInterface;  
    delivery_status: fromDatatype.VarcharDatatypeInterface;
    delivery_logic: fromDatatype.VarcharDatatypeInterface;
    process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_status_guid: fromDatatype.GuidDataFieldInterface;
    process_status_name: fromDatatype.VarcharDatatypeInterface;
    process_resolution_guid: fromDatatype.GuidDataFieldInterface;
    process_resolution_code: fromDatatype.VarcharDatatypeInterface;
    driver_name:fromDatatype.VarcharArrayDatatypeInterface;
    third_party_driver: fromDatatype.VarcharArrayDatatypeInterface;
    trip_driver_helper_guid: fromDatatype.GuidDataFieldInterface;
}